import { ReservationState } from '@mews-commander/data-access';
import { Tag, TagVariant } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText } from '@mews/framework';

type ReservationStateWithoutUndefined = Exclude<ReservationState, ReservationState.Undefined>;

const mapStatusToVariant: Record<ReservationStateWithoutUndefined, TagVariant> = {
    [ReservationState.Future]: 'basicSubtle',
    [ReservationState.ToBeCheckedIn]: 'denim',
    [ReservationState.CheckInMissed]: 'tangerine',
    [ReservationState.CheckedIn]: 'basicBold',
    [ReservationState.ToBeCheckedOut]: 'denim',
    [ReservationState.CheckOutMissed]: 'tangerine',
    [ReservationState.Past]: 'basicSubtle',
    [ReservationState.CheckedInOnline]: 'success',
    [ReservationState.CheckedOutOnline]: 'success',
    [ReservationState.Cancelled]: 'basicSubtle',
    [ReservationState.Optional]: 'basicSubtle',
    [ReservationState.Inquired]: 'basicSubtle',
};

const mapStatusToTextKey: Record<ReservationStateWithoutUndefined, Mews.TextKey> = {
    [ReservationState.Future]: TextKey.ReservationTimeStateFuture,
    [ReservationState.ToBeCheckedIn]: TextKey.ReservationTimeStateToBeCheckedIn,
    [ReservationState.CheckInMissed]: TextKey.ReservationTimeStateCheckInMissed,
    [ReservationState.CheckedIn]: TextKey.CheckedIn,
    [ReservationState.ToBeCheckedOut]: TextKey.ReservationTimeStateToBeCheckedOut,
    [ReservationState.CheckOutMissed]: TextKey.ReservationTimeStateCheckOutMissed,
    [ReservationState.Past]: TextKey.ReservationTimeStatePast,
    [ReservationState.CheckedInOnline]: TextKey.OnlineCheckedIn,
    [ReservationState.CheckedOutOnline]: TextKey.OnlineCheckedOut,
    [ReservationState.Cancelled]: TextKey.ServiceOrderStateCanceled,
    [ReservationState.Optional]: TextKey.ServiceOrderStateOptional,
    [ReservationState.Inquired]: TextKey.ServiceOrderStateInquired,
};

interface ReservationStatusTagProps {
    reservationStatus: ReservationStateWithoutUndefined;
}

export const ReservationStatusTag = ({ reservationStatus }: ReservationStatusTagProps) => {
    const variant = mapStatusToVariant[reservationStatus];
    const textKey = mapStatusToTextKey[reservationStatus];
    return (
        <Tag data-test-id="reservation-status-tag" variant={variant} outline>
            <LocalizedText textKey={textKey} />
        </Tag>
    );
};
